// import Transaction from "../ui/Transaction.vue";
import Address from "../ui/Address.vue";
import AddressFrom from "../ui/AddressFrom.vue";
import IsSuccessIcon from "../ui/IsSuccessIcon.vue";
// import Type from "../ui/Type.vue";
// import Amount from "../ui/Amount.vue";

export const columns = [
  {
    key: "hash",
    label: "Hash",
    component: Address,
    // classes: ['w-[125px] block md:table-cell col-span-2']
  },
  {
    key: "block",
    label: "Block",
    // classes: ['text-color-pink block w-[100px] md:table-cell col-span-2'],
  },
  {
    key: "age",
    label: "Age",
    // classes: ['text-color-gray block w-[100px] md:table-cell col-span-2']
  },
  {
    key: "from",
    label: "From",
    component: AddressFrom,
    // classes: ['w-[170px] block md:table-cell col-span-1'],
  },
  {
    key: "to",
    label: "To",
    component: Address,
    // classes: ['w-[130px] block md:table-cell col-span-1'],
  },
  {
    key: "amount",
    label: "Amount",
    // classes: ['w-[80px] block md:table-cell col-span-1'],
  },
  {
    key: "result",
    label: "Result",
    component: IsSuccessIcon,
    // classes: ['w-[40px] block md:table-cell col-span-1'],
  },
  // {
  //   key: "transaction",
  //   label: "Transaction",
  //   component: Transaction,
  //   width: "160px",
  // },
  // { key: "address", label: "Address", width: "160px", component: Address },
  // { key: "type", label: "Type", component: Type },
  // {
  //   key: "amount",
  //   label: "Amount",
  //   width: "270px",
  //   component: Amount,
  // },
];
